import { render, staticRenderFns } from "./VideoInput.vue?vue&type=template&id=ab19ed5a&"
import script from "./VideoInput.vue?vue&type=script&lang=js&"
export * from "./VideoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/agent_ai/agent-ai-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab19ed5a')) {
      api.createRecord('ab19ed5a', component.options)
    } else {
      api.reload('ab19ed5a', component.options)
    }
    module.hot.accept("./VideoInput.vue?vue&type=template&id=ab19ed5a&", function () {
      api.rerender('ab19ed5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/VideoInput.vue"
export default component.exports